module.exports = "/_next/static/images/aded1d635f9978c1479ab374fb25be53-digital-account-phone-main-screen@md-1x.png.webp";